export const priorityData = ["MUY BAJA", "BAJA", "MEDIA", "ALTA", "CRITICA"];
export const priorityDataTraduction= ["VERY_LOW", "LOW", "MEDIUM", "HIGH", "CRITICA"];
export const statusData = ["CREADA", "ASIGNADA", "EN GESTIÓN", "EN ANÁLISIS", "RESUELTA", "NO RESUELTA"];
export const statusDataTraduction = ["CREATED", "ASSIGNED", "IN_PROGRESS", "IN_ANALYSIS", "DONE", "REJECTED"];
export const incidentsTypes = ["INCIDENCIA PAGOS", "CAMBIO DE ESTADO", "ACTUALIZAR DATOS DE CONTRATO", "ACTUALIZAR DATOS DE CLIENTE", "AVANZAR CONTRATO", "ALTA USUARIOS", "INCIDENCIA SEGURO", "DOCUMENTACIÓN", "PERFILADO DE CLIENTE", "PERFILADO DE CONTRATO", "RENOVACIONES", "CANCELACIONES", "AMPLIACIONES", "ENVÍOS" ];
export const incidentsTypesTraduction = ["PAYMENT", "STATUS_CHANGE", "CONTRACT_UPDATE", "CUSTOMER_UPDATE", "CONTRACT_ADVANCE", "REGISTER_CUSTOMER", "POLICY", "DOCUMENTATION", "CUSTOMER_PROFILE", "CONTRACT_PROFILE", "RENEWAL", "CANCELLATION", "EXTENSION", "DELIVERY" ];






